import React, { useState, useEffect } from 'react';
import { venueService } from '../services/api';
import { getUserFacingApiError } from '../utils/apiErrors';

const FilterPanel = ({ filters, onFilterChange, isMobile }) => {
  const [cities, setCities] = useState([]);
  const [citiesError, setCitiesError] = useState(null);
  const [isOpen, setIsOpen] = useState(!isMobile);

  useEffect(() => {
    setCitiesError(null);
    venueService
      .getAll()
      .then((venues) => {
        const uniqueCities = [...new Set(venues.map((v) => v.city).filter(Boolean))].sort();
        setCities(uniqueCities);
      })
      .catch((err) => {
        console.error('Error fetching cities:', err);
        setCitiesError(getUserFacingApiError(err));
      });
  }, []);

  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const handleClearAll = () => {
    onFilterChange({ status: '', city: '', artist: '' });
  };

  const hasActiveFilters = Object.values(filters).some(v => v);

  return (
    <div className={`${isMobile ? 'mb-6' : ''}`}>
      {isMobile && (
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full btn btn-secondary mb-4 flex items-center justify-between"
        >
          <span>Filters</span>
          <svg 
            className={`w-5 h-5 transition-transform ${isOpen ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      )}
      
      <div className={`${isMobile && !isOpen ? 'hidden' : 'block'} ${!isMobile ? 'card p-4' : 'space-y-4'}`}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-slate-900">Filters</h3>
          {hasActiveFilters && (
            <button
              onClick={handleClearAll}
              className="text-sm text-brand hover:text-brand-dark"
            >
              Clear all
            </button>
          )}
        </div>

        {/* Status filter */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Status
          </label>
          <select
            value={filters.status || ''}
            onChange={(e) => handleFilterChange('status', e.target.value)}
            className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-brand focus:border-brand"
          >
            <option value="">All</option>
            <option value="current">Current</option>
            <option value="upcoming">Upcoming</option>
            <option value="ongoing">Ongoing</option>
          </select>
        </div>

        {/* City filter */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-slate-700 mb-2">
            City
          </label>
          {citiesError && (
            <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 mb-2">
              {citiesError}
            </p>
          )}
          <select
            value={filters.city || ''}
            onChange={(e) => handleFilterChange('city', e.target.value)}
            className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-brand focus:border-brand"
          >
            <option value="">All Cities</option>
            {cities.map(city => (
              <option key={city} value={city}>{city}</option>
            ))}
          </select>
        </div>

        {/* Artist filter */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-slate-700 mb-2">
            Artist
          </label>
          <input
            type="text"
            value={filters.artist || ''}
            onChange={(e) => handleFilterChange('artist', e.target.value)}
            placeholder="Search by artist name..."
            className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-brand focus:border-brand"
          />
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;
